import { CompanyDetailAndJobGroups } from '@types';
import { useSidebarItems } from './sidebar-items';

export const filterOutSidebarItems = (props: {
  sidebarItems: ReturnType<typeof useSidebarItems>;
  company: CompanyDetailAndJobGroups | undefined;
  allowAvailability: boolean;
  companyRoles: string[] | undefined;
}) => {
  const { sidebarItems, company, allowAvailability, companyRoles } = props;
  // creates shallow copy of sidebar items to avoid mutating the original array
  const result = sidebarItems.map((section) => ({
    ...section,
    children: [...section.children],
  }));

  if (!company?.company.offersEmployeeWork) {
    const planningSection = result.find((s) => s.key === 'planning');
    if (planningSection) {
      planningSection.children = planningSection.children.filter(
        (item) => item.path !== 'management/workforce'
      );
    }
  }

  if (!allowAvailability) {
    const planningSection = result.find((s) => s.key === 'planning');
    if (planningSection) {
      planningSection.children = planningSection.children.filter(
        (item) => item.path !== 'availability/*'
      );
    }
  }

  if (
    companyRoles === undefined ||
    !companyRoles?.length ||
    (!companyRoles.includes('ADMIN') && !companyRoles.includes('HQADMIN'))
  ) {
    const settingsSection = result.find((s) => s.key === 'settings');
    if (settingsSection) {
      settingsSection.children = [];
    }
  }

  return result;
};
